import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Payment from "@/pages/Payment";
import Subscribe from "@/pages/Subscribe";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import LiveTips from "@/pages/LiveTips";
import PaymentsDashboard from "@/pages/admin/PaymentsDashboard";
import SubscriptionDetail from "@/pages/admin/SubscriptionDetail";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/live-tips" component={LiveTips} />
      <Route path="/payment">
        {() => (
          <ProtectedRoute>
            <Payment />
          </ProtectedRoute>
        )}
      </Route>
      <Route path="/subscribe">
        {() => (
          <ProtectedRoute>
            <Subscribe />
          </ProtectedRoute>
        )}
      </Route>
      <Route path="/subscribe/success">
        {() => (
          <ProtectedRoute>
            <CheckoutSuccess />
          </ProtectedRoute>
        )}
      </Route>
      <Route path="/account">
        {() => (
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        )}
      </Route>
      <Route path="/admin/payments" component={PaymentsDashboard} />
      <Route path="/admin/payments/subscriptions/:id" component={SubscriptionDetail} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
